<template>
  <div class="flex flex-row">
    <router-link
      v-for="(link, index) in breadcrumbs"
      :key="link.to"
      :to="link.to"
    >
      <div class="flex flex-row">
        <p
          v-if="index !== 0"
          :class="{
            'text-sm': true,
            'px-2': true,
            'active-breadcrumb': activeBreadcrumb(index),
            'inactive-breadcrumb': inactiveBreadcrumb(index)
          }"
          style="font-family: 'Source Sans Pro';"
        >
          /
        </p>
        <vs-icon v-if="link.icon" :icon="link.icon"></vs-icon>
        <p
          :class="{
            'text-sm': true,
            'active-breadcrumb': activeBreadcrumb(index),
            'inactive-breadcrumb': inactiveBreadcrumb(index)
          }"
        >
          {{ link.title }}
        </p>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "Breadcrumbs",
  props: {
    breadcrumbs: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  methods: {
    activeBreadcrumb(index) {
      return index === this.breadcrumbs.length - 1;
    },
    inactiveBreadcrumb(index) {
      return index !== this.breadcrumbs.length - 1;
    }
  }
};
</script>

<style scoped>
.inactive-breadcrumb {
  color: #7367f099;
  transition: 0.3s;
}

.inactive-breadcrumb:hover {
  color: #7367f0;
}

.active-breadcrumb {
  color: #7367f0;
}
</style>
